export const areFiltersArraysEqual = <T>(arr1: T[][], arr2: T[][]): boolean => {
  if (!arr1.length || !arr2.length) return false;

  if (arr1.length !== arr2.length) return false;

  return !arr1.some((item: T[]) => arr2.find((i) => i[0] !== item[0] || i[1] !== item[1]));
};
